// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3Zqhf","boxTitle":"Qualiphy_boxTitle__3O4Fu","box":"Qualiphy_box__XaRzB","toggleWrap":"Qualiphy_toggleWrap__2n3CJ"};